import { useSelector } from "react-redux";

import LoginForm from "../auth/loginForm";
import { useEffect } from "react";
import { fetchEtablissementById } from "../../store/slices/etablissementSlice";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Layout from "./layout";
import { createRendezvous } from "../../store/slices/rendezVousSlice";

const Identification=()=>{
  const dispatch=useDispatch()
  const location=useLocation()
  const navigate=useNavigate()
  const data=location?.state
  // console.log({data})
  const {id}=useParams()
    const etablissement = useSelector(
        (state) => state.etablissements.selectedEtablissement
      );
      const prestations = useSelector(
        (state) => state.rendezvous.selectedPrestations
      );
      const afterLogin=async()=>{
         try {
                  // Dispatch the create appointment action
                  const resultAction = await dispatch(
                    createRendezvous(data)
                  );
        
                  if (createRendezvous.fulfilled.match(resultAction)) {
                    // Success case
                    localStorage.setItem('resultAction',JSON.stringify(resultAction?.payload?.reservation))
                     navigate(`/facturation/${resultAction?.payload?.reservation?.id}`);
                  } else {
                    // Handle error case
                    // console.error(
                    //   "Failed to create appointment:",
                    //   resultAction.payload
                    // );
                    // alert("Erreur lors de la création du rendez-vous");
                  }
                } catch (error) {
                  // console.error("Error creating appointment:", error);
                  // alert("Une erreur est survenue");
                }
      }
   useEffect(() => {
      dispatch(fetchEtablissementById(id));
    }, []);
    return(
        <>
        <Layout
        currentStep={2}
        etablissement={etablissement}
        prestation={prestations.filter((p) => p.selected)}
        recap={false}
        identification={true}
        conf={true}
        btn={false}
        from='reservation'

    >
      <div className="mb-24 mx-auto">
        <LoginForm from='rdv' id={etablissement?.id} after={afterLogin} appointmentData={data}/>
      </div>
      </Layout>
        </>
    )
}
export default Identification;